import {ChevronDown,Languages} from 'lucide-react';
import {useI18n} from '../locales/I18n';
import {isAvailableLanguage,languages} from '../locales/core';
import type {LanguageCode} from '../locales/core';
import {useState} from 'react';
import {useProfile} from '../auth/ProfileProvider';
export function LanguageSelector(){
 const {t,requestedLanguage,loadingLanguage,languageError,setLanguage,language}=useI18n();
 const profile=useProfile(),[saving,setSaving]=useState(false),[saveError,setSaveError]=useState(false);
 async function choose(code:LanguageCode){setSaveError(false);setSaving(true);try{if(profile?.profile)await profile.saveLanguage(code);await setLanguage(code);}catch{setSaveError(true);}finally{setSaving(false);}}
 const requested=languages.find(item=>item.code===requestedLanguage)!;
 return <div className="language-setting">
  <label className="language-picker"><Languages size={16} aria-hidden="true"/>
   <span className="sr-only">{t('App language')}</span>
   <select value={requestedLanguage} onChange={event=>void choose(event.target.value as LanguageCode)} aria-describedby="language-status" aria-busy={loadingLanguage||saving} disabled={saving}>
    {languages.map(item=><option key={item.code} value={item.code}>{t(item.name)}{item.code!=='en'&&isAvailableLanguage(item.code)&&language==='en'?' · '+item.native:''}</option>)}
   </select><ChevronDown size={14} aria-hidden="true"/>
  </label>
  <div id="language-status" className="language-status" role="status" aria-live="polite">
   {saveError&&t('Could not save your language. Please try again.')}
   {loadingLanguage?t('Loading {language}…',{language:requested.name}):languageError?<>{t('Could not load {language}. Please try again.',{language:requested.name})} <button className="text-link" onClick={()=>void setLanguage(requestedLanguage)}>{t('Try again')}</button></>:!isAvailableLanguage(requestedLanguage)?t('Translation coming soon. English is shown for now.'):null}
  </div>
 </div>;
}
